import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  imports: [AnimateOnScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsComponent {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().stats);

  stats = computed(() => this.t().items);
}